import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CommissionNote\PdfCommissionNoteListController::__invoke
* @see app/Http/Controllers/CommissionNote/PdfCommissionNoteListController.php
* @route '/api/commission-note-dashboard/pdf'
*/
const PdfCommissionNoteListController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: PdfCommissionNoteListController.url(options),
    method: 'post',
})

PdfCommissionNoteListController.definition = {
    methods: ["post"],
    url: '/api/commission-note-dashboard/pdf',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CommissionNote\PdfCommissionNoteListController::__invoke
* @see app/Http/Controllers/CommissionNote/PdfCommissionNoteListController.php
* @route '/api/commission-note-dashboard/pdf'
*/
PdfCommissionNoteListController.url = (options?: RouteQueryOptions) => {
    return PdfCommissionNoteListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CommissionNote\PdfCommissionNoteListController::__invoke
* @see app/Http/Controllers/CommissionNote/PdfCommissionNoteListController.php
* @route '/api/commission-note-dashboard/pdf'
*/
PdfCommissionNoteListController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: PdfCommissionNoteListController.url(options),
    method: 'post',
})

export default PdfCommissionNoteListController